'use client';
import React, { useEffect } from 'react';

export const FloorMap = () => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://floors-widget.api.2gis.ru/loader.js';
    script.id = 'dg-floors-widget-loader';
    document.head.appendChild(script);

    const mapglScript = document.createElement('script');
    mapglScript.src = 'https://unpkg.com/@2gis/mapgl-gltf@^2/dist/bundle.js';
    mapglScript.id = 'dg-mapgl-gltf-loader';
    document.head.appendChild(mapglScript);

    script.onload = () => {
      mapglScript.onload = () => {
        init();
      };
    };

    const init = () => {
      if (typeof DG === 'undefined') {
        return;
      }

      DG.FloorsWidget.init({
        container: 'floor',
        width: '100%',
        height: '100%',
        initData: {
          complexId: '141373143573143',
          options: { initialSearchQuery: false },
        },
      });
    };
  }, []);

  return (
    <section
      id="floor"
      className="h-full w-full"
      style={{ touchAction: 'none' }}
    />
  );
};
